import React from 'react';
import { NavBarNine } from "master-react-lib";
import Logo from '../assets/imgs/dc-abrar-website-logo.png';

import facebook from '../assets/imgs/facebook.png';
import youtube from '../assets/imgs/youtube.png';
import twitter from '../assets/imgs/twitter.png';

import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded';

function Header() {

    const socialIconData = [
        {
            icon: <img src={facebook} />,
            iconColor: "#1877F2",
            link: "https://www.facebook.com/theAbrarNYC/",
        },

        {
            icon: <img src={youtube} />,
            iconColor: "#F44336",
            link: "https://www.youtube.com/channel/UCW31JSvDCszmIMcMvsiIKng/channels",
        },

        // {
        //     icon: <img src={twitter} />,
        //     iconColor: "#03A9F4",
        //     link: "https://twitter.com/",
        // },
    ];


    return (
        <div className="MainHeader">
            <NavBarNine
                logo={Logo}
                logoLink="/"
                background="#fff"
                maxWidth="1175px"
                LogoSize="90px"
                socialIconData={socialIconData}
                EmailLebel="EMAIL US AT"
                Email="support@theabrar.org"
                PhoneLebel="CALL US"
                Phone="+1 347-326-5326"

            />
        </div>
    );
}


export default Header;